module.exports = __webpack_public_path__ + "img/appStoreLight.1f4e7ecd.svg";